import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "heartFilled"
const HeartFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M15.361 18.283 12 21.084 8.639 18.284 12 14.25zM16.5 3.75C19.4 3.75 21.75 6.1 21.75 9 21.75 10.377 21.274 11.461 21.002 12.004 20.688 12.633 20.314 13.18 19.997 13.604 19.358 14.453 18.597 15.263 17.963 15.9 17.304 16.558 16.66 17.147 16.19 17.564 15.953 17.775 15.754 17.95 15.61 18.072L15.437 18.219 15.387 18.262 15.37 18.275 15.365 18.28 15.362 18.283S15.334 18.25 12 14.25L8.638 18.283 8.635 18.28 8.63 18.275 8.613 18.262 8.562 18.219 8.39 18.072C8.246 17.949 8.047 17.775 7.81 17.564 7.34 17.147 6.695 16.558 6.036 15.9 5.402 15.265 4.642 14.454 4.003 13.603 3.686 13.18 3.312 12.633 2.998 12.004 2.726 11.461 2.25 10.377 2.25 9 2.25 6.1 4.6 3.75 7.5 3.75 9.41 3.75 11.082 4.77 12 6.296 12.918 4.77 14.59 3.75 16.5 3.75" />
        </svg>
      }
    </span>
  )
}
export default HeartFilledIcon
